import React, { useState ,useEffect} from 'react';
import Axios from '../../lib/axios/axiosInstance';
import Faq from "react-faq-component";

const styles = {
  // bgColor: 'white',
  titleTextColor: "var(--navBG)",
  rowTitleColor: "var(--navBG)",
  // rowContentColor: 'grey',
  // arrowColor: "red",
};

const config = {
  animate: true,
  arrowIcon: <><i class="fa fa-plus-circle" style={{ color:'var(--navBG)'}}></i></>,
  // tabFocus: true
};

const Helpdesk = () => {
  const [faqs,setFaqs] = useState(false);

  useEffect(() => {
    Axios.get(`/cms/FAQ`)
        .then(async (faq) => {
            if (faq.status == 200 && faq.data.data.faq) {
              var editedFas={
                title: "Frequently asked questions (FAQ)",
                rows:[]
              };
              faq.data.data.faq.forEach(element => {
                editedFas.rows.push({
                  title:element.question,
                  content:element.answer
                })
              });
              setFaqs(editedFas);
            }
        })
	},[])

  return (
    <>
    <div className="container">
    <br />
    <div id="accordion">
      {faqs && 
        <Faq
            data={faqs}
            styles={styles}
            config={config}
        />
      }
      </div>
  </div>
    <br />
    <br />
    </>
  );
};

export default Helpdesk;
